import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonProps, ButtonPropsVariantOverrides } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

import {
  FlipProp,
  PullProp,
  RotateProp,
  SizeProp,
} from "@fortawesome/fontawesome-svg-core";

import { ICONS } from "./Icon/icons";

export enum STATUS {
  NONE = "none",
  SUCCESS = "success",
  WARN = "warn",
  ERROR = "error",
  INFO = "info",
  NEUTRAL = "neutral",
  PURPLE = "purple",
}

type ButtonVariant = OverridableStringUnion<
  "text" | "outlined" | "contained" | "inline-text" | "link-text",
  ButtonPropsVariantOverrides
>;

type ExtendedButtonProps = Omit<ButtonProps, "children" | "variant"> & {
  label?: string;
  visible?: boolean;
  dataTestId?: string;
  children?: React.ReactNode;
  variant?: ButtonVariant;
  href?: string;
  target?: string;
};

export type { ExtendedButtonProps as ButtonProps, ButtonVariant };

type FAIconProps = React.ComponentProps<typeof FontAwesomeIcon>;

export interface IconProps extends Omit<FAIconProps, "icon" | "onClick"> {
  icon: keyof typeof ICONS;
  size?: SizeProp;
  fixedWidth?: boolean;
  rotation?: RotateProp;
  flip?: FlipProp;
  color?: string;
  border?: boolean;
  pull?: PullProp;
  animation?:
    | "beat"
    | "beatFade"
    | "bounce"
    | "fade"
    | "shake"
    | "spin"
    | "spinReverse"
    | "spinPulse";
  onClick?: () => void;
  disabled?: boolean;
}

export type Option<T = string | number> = {
  label: string;
  value: T;
  disabled?: boolean;
};

export type Tab = {
  label: string;
  url: string;
  parentUrl?: string | undefined;
  badgeValue?: number | string;
};

export type BasicTab = {
  label: string;
  hasError?: boolean;
  errorTooltip?: string;
  hasWarning?: boolean;
  warningTooltip?: string;
  customBorderColor?: string;
  tooltipValue?: string;
  disabled?: boolean;
  disabledTooltip?: string;
  render: () => React.ReactNode;
};
